import { render, staticRenderFns } from "./PoxChart.vue?vue&type=template&id=5032dc6f&scoped=true"
import script from "./PoxChart.vue?vue&type=script&lang=js"
export * from "./PoxChart.vue?vue&type=script&lang=js"
import style0 from "./PoxChart.vue?vue&type=style&index=0&id=5032dc6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032dc6f",
  null
  
)

export default component.exports